import { NumberInput, NumberInputProps, useTranslate } from 'react-admin';
import { Box, InputLabel } from '@mui/material';
import { InputHelperUnderLabel } from './InputHelperUnderLabel';

export const GrayNumberInputWithUpperLabel = (props: NumberInputProps & { isRequired?: boolean }) => {

  const translate = useTranslate();
  const {
    helperText, isRequired, label, className, ...rest
  } = props;

  return (
    <Box display="flex" flexDirection="column">
      {label !== false && (
        <InputLabel className="input-label" required={isRequired}>
          {translate(typeof label === 'string' ? label : '', { _: label })}
        </InputLabel>
      )}
      <InputHelperUnderLabel helperText={helperText} />
      <NumberInput
        {...rest}
        className={className ? `${className} bhvk-gray-input` : 'bhvk-gray-input'}
        label={false}
        InputProps={{
          ...props.InputProps,
          notched: false,
        }}
        sx={{
          mt: 0,
          mb: 0,
          ...props.sx,
          '& .MuiOutlinedInput-root': {
            boxSizing: 'border-box',
            minHeight: props.size === 'small' ? 40 : 56,
            height: props.size === 'small' ? 40 : 56,
            alignItems: 'center',
          },
        }}
      />
    </Box>
  );

};
